
import BookSummary from "@/app/components/BookSummary.vue";

export default {
  components: {BookSummary},
  props: ['book']
}
